import styled from 'styled-components';
import { Link } from 'gatsby';

const Container = styled.div`
  .widget {
    background: linear-gradient(90deg, rgba(50, 50, 50, 1) 0%, rgba(30, 30, 40, 1) 100%);
    border-radius: 5px;
    box-shadow: 2px 1px 3px rgba(0, 0, 0, 0.3);
    display: flex;
    height: 35px;
    position: absolute;

    &:hover {
      cursor: pointer;
    }
  }

  .options-icon {
    border-left: 1px solid #888;
    padding-left: 10px;
    width: 28px;
  }

  p {
    color: white;
    font-size: 14px;
    margin: 0 0 0 10px;
  }
`;

const CloseModal = styled.div`
  align-items: center;
  background: linear-gradient(180deg, rgba(204, 0, 0, 1) 0%, rgba(190, 0, 0, 1) 100%) !important;
  display: block;
  justify-content: center;
  justify-content: space-between !important;
  padding: 0 10px 0 12px;
  position: fixed !important;
  right: 100px;
  right: 40px;
  top: 10px;
  width: 140px;
  z-index: var(--z-max);

  p {
    margin: 0;
  }

  &.closed {
    display: none;
  }
`;

const PageWidget = styled.div`
  align-items: center;
  background: ${({ isCloseModalOpen }) =>
    `linear-gradient(90deg, rgba(50, 50, 50, ${
      isCloseModalOpen ? '0.5' : '1'
    }) 0%, rgba(30, 30, 40, ${isCloseModalOpen ? '0.5' : '1'}) 100%)`} !important;
  color: white;
  justify-content: space-between;
  padding: 0 10px 0 4px;
  position: fixed !important;
  right: 40px;
  top: 10px;
  width: 124px;
  z-index: var(--z-max);

  p {
    margin: 0 0 0 10px;
`;

const Widget = styled(Link)`
  ${({ isHeader }) => (isHeader ? 'left: 40px' : 'right: 40px')};
  align-items: center;
  background: linear-gradient(90deg, rgba(50, 50, 50, 1) 0%, rgba(30, 30, 40, 1) 100%);
  justify-content: center;
  top: ${({ isHeader, isHero }) => (isHeader ? '20px' : isHero ? '140px' : '40px')};
  width: ${({ isPage }) => (isPage ? '120px' : '35px')};
  z-index: ${({ isHeader }) => (isHeader ? 'var(--z-max)' : 'var(--z-marketingpro-subnav)')};

  &:hover {
    cursor: pointer;
  }

  img {
    height: auto;
    width: 17px;
  }
`;

export { CloseModal, Container, PageWidget, Widget };
